import { useMutation, useQuery } from '@apollo/client';
import { UpdateDomain } from 'Apollo/mutations/organization/UpdateDomain';
import { GetOrganizationDomains } from 'Apollo/queries/organization/GetOrganizationDomains';
import useNotification from 'Hooks/useNotification';
import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ROW_PER_PAGE_DEFAULT } from 'Theme/config';
import OrganizationSecurity from './OrganizationSecurity';

function OrganizationSecurityContainer() {
  const { onError } = useNotification();
  const { organizationCode } = useParams<{ organizationCode: string }>();
  const [rowsPerPage, setRowsPerPage] = useState<number>(ROW_PER_PAGE_DEFAULT);
  const [currentPage, setCurrentPage] = useState<number>(0);

  const { data, loading } = useQuery<
    GetOrganizationDomainsData,
    GetOrganizationDomainsVars
  >(GetOrganizationDomains, {
    fetchPolicy: 'cache-and-network',
    variables: {
      code: organizationCode,
      page: {
        first: rowsPerPage,
        offset: currentPage * rowsPerPage
      }
    },
    onError
  });

  const [updateDomain] = useMutation<
    UpdateOrganizationDomainData,
    UpdateOrganizationDomainVariables
  >(UpdateDomain, { onError });

  const handleToggle = useCallback(
    (row: IOrganizationDomain, field: 'forceTotp' | 'forceEmail') => {
      updateDomain({
        variables: {
          code: organizationCode,
          name: row.name,
          input: {
            forceTotp: field === 'forceTotp' ? !row.forceTotp : row.forceTotp,
            forceEmail: field === 'forceEmail' ? !row.forceEmail : row.forceEmail
          }
        },
        refetchQueries: [GetOrganizationDomains]
      });
    },
    [organizationCode, updateDomain]
  );

  const allDomains = data?.organizationDomains.edges.map(edge => edge.node) ?? [];
  const domains = allDomains.filter(domain => domain.validated);
  const totalCount = domains.length;

  return (
    <OrganizationSecurity
      loading={loading}
      domains={domains}
      totalCount={totalCount}
      currentPage={currentPage}
      onChangePage={setCurrentPage}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={setRowsPerPage}
      onHandleToggle={handleToggle}
    />
  );
}

export default OrganizationSecurityContainer;
